//import * as React from "react";
import React, { useRef, useEffect, useState } from "react";

//import './styles.css';
import validacion from "components/nubox/NuInput/validacion"
//import Errors from "../Errors";
//import Icon from "../Icon";
//--- pueden ser varias piezas 2,5,4
const PatternValidation = (valor, tipo) => {
  const regex = new RegExp('^[0-9]*([,][0-9]+)*$');    
  return regex.test(valor);
};
//-----------------------------------------------------------------------
const InputNumber = ({ 
  className,
  containerStyle,
  errors,
  disabled,
  icon,
  inputStyle,
  name,
  onChange,
  
  placeholder,
  readOnly,
  required,
  type,
  value,
  wrapperStyle,
  valtipo='',
  classError='is-invalid',
  autoComplete="off",
  max=100,
  min=0,
}) => {
  const inputRef = React.useRef(null);

  const [cad_error,setCadError] = React.useState(""); //cadena de errro
  //const classRequired = ref("")
  /*useEffect(() => {
    className = "appointment-item " + (selected ? "selected" : "");
    console.log(className );
  }, [selected] );*/
  //-------------------------------------------
  const handleClick = () => {
    if (inputRef && inputRef.current) inputRef.current.focus();
  };
  //-------------------------------------------
  const handleChange = (e) => {
    //---- lo validamos
    //---si es correcto retorna cadena vacia
    //---sino, retorna el error
    //let cad = validacion(e.target.value, valtipo );
    let valor = e.target.value

    let cad = PatternValidation(e.target.value, valtipo );
    setCadError(cad);
    //-----------pintamos si corresponde
    if(valor>=min && valor<=max){
      //todo correcto
    }else{
      //setCadError("Error")
      //alert("numero no valido");
      //e.target.value=''
      classError="is-invalid";
    }
    /*if(cad!==""){
      classError="is-invalid";
    }*/
    //---llamamos al obChange del padre
    onChange(e);
  }
  //---------------------------------------
  const onFocusOut=(e)=>{
    e.preventDefault();
    //console.log('event.target', e.target);
    //event.target.value
    if(e.target.value===''){ 
      setCadError('No valido');
      return 
    }
    let valor =  parseInt( e.target.value )
    if(valor===0 || (valor>= min && valor<=max) ){
      //correcto
    }else{
      //---numero no valido
      alert(`Valor ${valor}, no valido, min=${min} y max=${max}`)
      //if(ret==true){   //true=OK    false=CANCEL
        //- el valor lo volvemos ''
        setCadError('No valido');
        e.target.value=''
        inputRef.current.focus()
        //onChange(e);
      //}
    }
    /*if (!event.currentTarget.contains(event.relatedTarget)) {
      
    }*/
  }

  return (
    <div className={""} style={wrapperStyle}>
      {
       //JSON.stringify(required) 
       //JSON.stringify(value==="") 
       //JSON.stringify(cad_error==="") 
       //JSON.stringify(classError==="") 
       //className= {` ${className} ${cad_error==="" ? '': classError} ${required===false? '': classError} ` }
       }
      
      <div onClick={handleClick} className="" style={containerStyle}>
        <input
          ref={inputRef}
          //aria-label={name}
          //data-testid={name}
          tabIndex={0}
          type={type}
          name={name}
          onChange={handleChange}
          onBlur={onFocusOut}
          placeholder={placeholder}
          value={value}
          style={inputStyle}
          disabled={disabled}
          readOnly={readOnly}
          className= {` ${className} ${cad_error==="" ? '': classError} ` }
          valtipo={valtipo}
          autoComplete={autoComplete}
        />
      </div>
      { value==="" && required && (
        <div ><span className="text-danger">.</span></div>
      )}
      { cad_error!=='' &&
        <div className="text-danger">{ cad_error }</div>  
      }
    </div>
  );
};

InputNumber.defaultProps = {
  className:'',
  containerStyle:{},
  errors:'',
  disabled:false,
  icon:'',
  inputStyle:{},
  name:'',
  onChange:(e)=>{},
  placeholder:'',
  readOnly:false,
  required:false,
  type:'text',
  value:'',
  wrapperStyle:{},
  valtipo:'',
  classError:'is-invalid',
  autoComplete:"off",
  max:100,
  min:0,
  onClick: function(){ alert("Hello"); }
};

export default InputNumber;

